import { ClassData } from "../../../common/dtos/classes.type";
import { Storage } from "../../../common/services/storage.service";
import {
  addDays,
  getDay,
  setHours,
  setMinutes,
  setSeconds,
  setMilliseconds,
} from "date-fns";

export function setGridClick(event: any, data: ClassData) {
  const link = event.target.getAttribute("data-target-link");
  if (!link) {
    return;
  }
  const name = Storage.get("name");
  const email = Storage.get("email");
  const phone = Storage.get("phone");
  const url = new URL(link, window.location.origin);
  if (name) url.searchParams.append("name", name);
  if (email) url.searchParams.append("email", email);
  if (phone) url.searchParams.append("phone", phone);
  url.searchParams.append("id", data.id.toString());
  url.searchParams.append("className", data.name);
  const totalTime = getUnixTimestamp(data);
  url.searchParams.append("trialTime", totalTime.toString());

  window.open(url.toString(), "_blank");
}

function getUnixTimestamp(data: ClassData): number {
  const meetingDays = data.meeting_days;
  const dayNames = ["sun", "mon", "tue", "wed", "thu", "fri", "sat"];

  const classDayIndex = dayNames.findIndex(
    (day) => meetingDays[day as keyof typeof meetingDays]
  );

  if (classDayIndex === -1) {
    throw new Error("No meeting days found for this class");
  }

  const [hours, minutes] = data.start_time.split(":").map(Number);
  const tomorrow = addDays(new Date(), 1);
  const tomorrowDayOfWeek = getDay(tomorrow);
  const tomorrowIndex = tomorrowDayOfWeek === 0 ? 7 : tomorrowDayOfWeek;

  let targetDate: Date | null = null;

  for (let i = 1; i <= 7; i++) {
    let dayDate: Date;

    if (i >= tomorrowIndex) {
      const daysFromToday = i - tomorrowIndex;
      dayDate = addDays(tomorrow, daysFromToday);
    } else {
      const daysFromToday = 7 - tomorrowIndex + i;
      dayDate = addDays(tomorrow, daysFromToday);
    }

    const dayOfWeek = getDay(dayDate);

    if (dayOfWeek === classDayIndex) {
      targetDate = dayDate;
      break;
    }
  }

  if (!targetDate) {
    throw new Error("Class day not found in the 7-day window");
  }

  const classDateTime = setMilliseconds(
    setSeconds(setMinutes(setHours(targetDate, hours), minutes), 0),
    0
  );

  return convertToGymTime(classDateTime);
}

function convertToGymTime(date: Date): number {
  const timezone = ryb_connect_connection_details.timezone;
  try {
    if (timezone) {
      const localeDateTimeString = date.toLocaleString("en-US", {
        timeZone: timezone,
        hour12: false,
      });
      const localDate = new Date(localeDateTimeString);

      return Math.floor(localDate.getTime() / 1000);
    }
  } catch (error) {
    if (timezone) {
      console.warn("Invalid timezone", error);
    }
  }
  const gmtMinus5Offset = 5 * 60 * 60 * 1000;
  return Math.floor((date.getTime() - gmtMinus5Offset) / 1000);
}
